import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'edl-modal-api-response',
    templateUrl: './edl-modal-api-response.component.html',
    styleUrls: ["./edl-modal-api-response.component.scss"],
})
export class EdlModalApiResponse {
    @Input() responses: { firstName: string, lastName: string, description: string; statusCode: number; message: string;}[];
    @Input() title: string;
    @Input() successLabel: string;
    @Input() failedLabel: string;

    constructor(public activeModal: NgbActiveModal) {}
}
